import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing a filter registration view.
 * @extends JetView
 */
export default class FilterRegisterFastView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Left section containing input fields for document registration
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for document type selection
                            name: 'DocumentType',
                            minWidth: 200,
                            label: _('Tipo Documento'), // Label for document type
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for document types
                                { id: '0', value: _('Cedula de Ciudadania') },
                                { id: '1', value: _('Cedula de Extranjeria') },
                                { id: '2', value: _('Pasaporte') },
                            ],
                        },
                        {
                            view: 'text', // Input for first name
                            name: 'FirstName',
                            minWidth: 200,
                            label: _('Primer Nombre:'),
                            labelPosition: 'top',
                            placeholder: _('Primer Nombre'),
                        },
                        {
                            view: 'text', // Input for document number
                            name: 'DocumentNumber',
                            minWidth: 200,
                            label: _('Nro Documento:'),
                            labelPosition: 'top',
                            placeholder: _('Nro Documento'),
                        },
                        {
                            view: 'text', // Input for second name
                            name: 'SecondName',
                            minWidth: 200,
                            label: _('Segundo Nombre:'),
                            labelPosition: 'top',
                            placeholder: _('Segundo Nombre'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Input for surname
                            name: 'Surname',
                            minWidth: 200,
                            label: _('Primer Apellido:'),
                            labelPosition: 'top',
                            placeholder: _('Primer Apellido'),
                        },
                        {
                            view: 'text', // Input for second surname
                            name: 'SecondSurname',
                            minWidth: 200,
                            label: _('Segundo Apellido:'),
                            labelPosition: 'top',
                            placeholder: _('Segundo Apellido'),
                        },
                        { id: 'grav', gravity: 2 }, // Gravity for layout adjustment
                    ],
                },
            ],
        };

        // Upper section containing the left input fields
        const upper_section = {
            css: 'father-container',
            id: 'upper_section',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including left section
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    minWidth: 200,
                    width: 100,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('registerFast:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse accordion
                        $$('a5').scrollTo(100, 0); // Scroll to specific position
                    },
                },
            ],
        };

        // Second button section for another form
        const buttons2 = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button for second form
                    value: _('Limpiar'),
                    minWidth: 200,
                    width: 100,
                    click: () => {
                        $$('myForm2').clear(); // Clears the second form
                    },
                },
                {
                    view: 'button', // Consult button for second form
                    value: _('Consultar'),
                    type: 'form',
                    width: 110,
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get values from second form
                        this.app.callEvent('registerFast:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Accordion section containing filters
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion view for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Including upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for the second form
        const accordion_section3 = {
            padding: 10,
            rows: [upper_section, buttons2], // Including upper section and second buttons
        };

        // Popup window for filters
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // ID for the second form
                type: 'clean',
                rows: [accordion_section3], // Including accordion section
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for first name
                },
            },
        });

        // Main form configuration
        return {
            view: 'form',
            id: 'myForm', // ID for the main form
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { id: 'right2', height: 1, width: screen.width - 54 }, // Fallback for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for first name
            },
        };
    }

    /**
     * Initializes the view.
     */
    init() {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide gravity element on small screens
            }
        });
    }
}

// FILE DOCUMENTED
